import { Injectable,Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class WebengageService {
  private webengage:any;
  constructor(@Inject(DOCUMENT) private document: Document) { }
  
  public trackEvent(eventName: any, eventData?:any): void {
    try{
    this.webengage = this.document.defaultView.webengage;
    this.webengage.track(eventName,eventData);
    }
    catch(e){
      console.log('webengage ERROR ',e)
    }
  }
  public webengageUserLogin(encryptedMob){
    try{
      this.webengage.user.login(encryptedMob);
    }catch(e){
      console.log('webengage ERROR ',e)
    }
  }
  public webengageTrackUser(userKey, userData){
    try{
      // webengage specific function
      this.webengage.user.setAttribute(userKey, userData);
    }catch(e){
      console.log('webengage ERROR ',e)
    }
  }
}
